export default "__VITE_ASSET__DeH1uMza__"